/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Time_InInputs */

const en_orders_time_in = /** @type {(inputs: Orders_Time_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time In`)
};

const es_orders_time_in = /** @type {(inputs: Orders_Time_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de entrada`)
};

/**
* | output |
* | --- |
* | "Time In" |
*
* @param {Orders_Time_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_time_in = /** @type {((inputs?: Orders_Time_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Time_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_time_in(inputs)
	return es_orders_time_in(inputs)
});